import React from 'react';
import { SupportedCredentialsQuery } from '../graphql/types';
import { ContentfulIntegration } from '../lib/contentfulClient';

export type IntegrationsContextType = {
  allIntegrations: ContentfulIntegration[];
  supportedIntegrations: ContentfulIntegration[];
  exchangeCredentials: SupportedCredentialsQuery['supportedCredentials']['exchangeCredentials'];
  supportedWallets: string[];
  evmCredentialTypes: string[];
  solanaCredentialTypes: string[];
  loading: boolean;
  isReconCredentialType: (id: string) => boolean;
  integrationsById: Map<string, ContentfulIntegration>;
  metadata: Map<string, { iconUrl?: string | null }>;
};

export const IntegrationsContext = React.createContext<IntegrationsContextType>({
  allIntegrations: [],
  supportedIntegrations: [],
  exchangeCredentials: [],
  supportedWallets: [],
  evmCredentialTypes: [],
  solanaCredentialTypes: [],
  loading: true,
  integrationsById: new Map(),
  isReconCredentialType: () => false,
  metadata: new Map(),
});

IntegrationsContext.displayName = 'IntegrationsContext';
